import { Icon } from '@shopify/polaris';
import { SearchIcon, XCircleIcon } from '@shopify/polaris-icons';

interface HelpSearchProps {
  query: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function HelpSearch({
  query,
  onChange,
  placeholder = 'Search help articles, FAQs...',
}: HelpSearchProps) {
  return (
    <div
      style={{
        position: 'relative',
        marginBottom: '24px',
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: '16px',
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#637381',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Icon source={SearchIcon} />
      </div>
      <input
        type="text"
        value={query}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: '100%',
          height: '48px',
          padding: '0 48px 0 48px',
          fontSize: '15px',
          border: '1px solid #e1e3e5',
          borderRadius: '8px',
          backgroundColor: 'white',
          outline: 'none',
          transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        }}
        onFocus={(e) => {
          e.currentTarget.style.borderColor = '#2c6ecb';
          e.currentTarget.style.boxShadow = '0 0 0 3px rgba(44, 110, 203, 0.15)';
        }}
        onBlur={(e) => {
          e.currentTarget.style.borderColor = '#e1e3e5';
          e.currentTarget.style.boxShadow = 'none';
        }}
      />
      {query && (
        <button
          onClick={() => onChange('')}
          style={{
            position: 'absolute',
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            color: '#637381',
            display: 'flex',
            alignItems: 'center',
          }}
          aria-label="Clear search"
        >
          <Icon source={XCircleIcon} />
        </button>
      )}
    </div>
  );
}
